///////////////////
// Auto-generated
// Do not edit!!!
///////////////////
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthCallbackComponent } from './auth-callback/auth-callback.component';
import { AppLayoutViewComponent } from './modules/application/app-layout/app-layout.view.component';
import { AuthenticationGuardService } from './core/auth/authentication-guard.service';

import { RacuniViewComponent } from './modules/transparentnost/racuni/racuni.view.component';

const routes: Routes = [
    {
        path: 'auth-callback',
        component: AuthCallbackComponent,
    },
    {
        path: '',
        component: AppLayoutViewComponent,
        canActivate: [AuthenticationGuardService],
        children: [
            { path: '', component: RacuniViewComponent, pathMatch: 'full', canActivate: [AuthenticationGuardService] },

            {
                path: 'transparentnost',
                loadChildren: './modules/transparentnost/transparentnost.module#TransparentnostModule',
            },
        ],
    },
    { path: '**', redirectTo: '' },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
    providers: [],
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// C:/Users/vjug.INFODESIGN/OtvoreniGrad2/app/src/app/app-routing.module.ts